import { clientStorage } from '../firebase';
import { iNoteFile } from '../interfaces';

export interface UploadFileOptions {
  file: File;
  storagePath: string;
  filename?: string;
}

export interface UploadFileResult {
  fileInfo: iNoteFile | null;
  error: string | null;
}

export const uploadFileToFirebase = async (
  options: UploadFileOptions,
): Promise<UploadFileResult> => {
  const { file, storagePath, filename } = options;

  if (!file || !(file instanceof File)) {
    return {
      fileInfo: null,
      error: 'Invalid file provided',
    };
  }

  try {
    const finalFilename = filename || `${Date.now()}_${file.name}`;
    const fullPath = `${storagePath}/${finalFilename}`;

    const fileRef = clientStorage().child(fullPath);
    await fileRef.put(file);

    const url = await fileRef.getDownloadURL();

    const format: 'pdf' | 'image' = file.type.includes('pdf') ? 'pdf' : 'image';

    return {
      fileInfo: {
        url,
        fileName: file.name,
        format,
      },
      error: null,
    };
  } catch (error) {
    console.error('Error uploading file to Firebase:', error);
    return {
      fileInfo: null,
      error: error instanceof Error ? error.message : 'Failed to upload file',
    };
  }
};

export const uploadNoteFile = async (
  file: File,
  deviceId: string,
): Promise<iNoteFile | null> => {
  const result = await uploadFileToFirebase({
    file,
    storagePath: `devices/device-details/${deviceId}/notes`,
  });

  if (result.error) {
    console.error('Error uploading note file:', result.error);
    return null;
  }

  return result.fileInfo;
};

export const uploadDynamicFieldFile = async (
  file: File,
  deviceId: string,
  fieldId: string,
): Promise<iNoteFile | null> => {
  const result = await uploadFileToFirebase({
    file,
    storagePath: `devices/device-details/${deviceId}/notes/extra-fields/${fieldId}`,
  });

  if (result.error) {
    console.error(`Error uploading file for field ${fieldId}:`, result.error);
    return null;
  }

  return result.fileInfo;
};